import { render, staticRenderFns } from "./ModalContentPosting.vue?vue&type=template&id=2a8e5b3c"
import script from "./ModalContentPosting.vue?vue&type=script&lang=js"
export * from "./ModalContentPosting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports